import { render, staticRenderFns } from "./CategoriesLateral.vue?vue&type=template&id=5ea9a7b6&scoped=true&"
import script from "./CategoriesLateral.vue?vue&type=script&lang=js&"
export * from "./CategoriesLateral.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesLateral.vue?vue&type=style&index=0&id=5ea9a7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9a7b6",
  null
  
)

export default component.exports